export const TextStyling = {
    variants: {
        error: {
            color: "errorRed",
            fontSize: 'sm',
            textAlign: 'center',
            mt: 1
        }
    }
};